import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
// import { NavigationActions } from 'react-navigation'
import StoreSellerView from 'xui/modules/storeSeller/StoreSellerView'
import * as StoreActions from 'x/modules/store/StoreState'
import { getSelectedStore, getMyStoresDetail, getMyStores } from 'x/redux/selectors'

export default connect(
  (state) => ({
    myStores: getMyStores(state),
    //   myStoresDetail: getMyStoresDetail(state),
    //   selectedStore: getSelectedStore(state),
    //   isReady: state.getIn(['session', 'isReady']),
    //   profile_img_uri: state.getIn(['profile', 'img_uri']),
  }),
  (dispatch) => {
    return {
      // navigate: bindActionCreators(NavigationActions.navigate, dispatch),
      dispatch,
      leaveFromStore: bindActionCreators(StoreActions.leaveFromSellerStore, dispatch),
      // storeActions: bindActionCreators(StoreState, dispatch),
      // loadProfile: bindActionCreators(ProfileActions.fetchUserProfile, dispatch),
    }
  }
)(StoreSellerView)
